<div class="min-h-screen flex flex-col">
    <!-- Header -->
    <app-asahi-navbar></app-asahi-navbar>

    <!-- Main content -->
    <main id="details" class="flex flex-col flex-1 justify-center items-center bg-[#E3E4E8] pt-8 pb-8 sm:p-8">
        <!-- First box -->
        <div class="flex flex-col sm:flex-row w-[90%] h-full p-8 justify-center sm:items-center gap-8
                        rounded-t-[32px] border-t border-l border-[#F53773] bg-[#FFF]
                        shadow-[0_4px_80px_0_rgba(0,0,0,0.08)]">

            <!-- First image: show only on small screens -->
            <div
                class="bg-[url('/png/46e569e597ad004d9822a1b12213dab7dd464c97.jpg')] sm:hidden w-full h-40 bg-contain bg-no-repeat bg-center">
            </div>

            <!-- Content -->
            <div class="flex flex-col items-start gap-8 flex-[1_0_0]">
                <span class="text-[#121212] font-[Manrope] text-[18px] not-italic font-bold leading-[34px]">
                    {{'Your premium' | translate}}
                </span>
                <h1
                    class="text-[#F5375C] font-[Manrope] text-[22.281px] not-italic font-normal leading-normal tracking-[-0.446px]">
                    <span class="font-bold text-[35px]">{{ responseData ?? '0'  | number}} {{'VND/year' | translate}}
                    </span>
                </h1>
                <!-- <p
                    class="rotate-[0.194deg] self-stretch text-[#121212] font-[Manrope] text-[16px] not-italic font-normal leading-[26px]">
                    Per year, billed annually
                </p> -->
            </div>

            <!-- Last image: hide on small screens, show on sm and above -->
            <div
                class="hidden sm:block w-[15%] min-w-[100px] flex-shrink-0 self-stretch 
                            bg-[url('/png/46e569e597ad004d9822a1b12213dab7dd464c97.jpg')] bg-contain bg-no-repeat bg-center">
            </div>

        </div>
        <!-- Second box -->
        <div class="flex w-full max-w-[95%]  sm:max-w-[90%] h-[80px] gap-2 items-center px-8 py-4
                    rounded-tl-[16px] border border-[rgba(255,255,255,0.16)]
                    bg-[linear-gradient(90deg,rgba(18,18,18,0.08)_0%,rgba(238,238,238)_7%)] mt-6">
            <img src="/png/CheckCircle.svg" alt="Check Circle" class="w-6 h-6 flex-shrink-0" style="fill: #1AAA69;" />
            <h1
                class="text-[#121212] font-[Manrope] text-[24px] not-italic font-semibold leading-[43.556px] flex-[1_0_0]">
                {{'Main Coverage' | translate}}
            </h1>
        </div>
        <table class="w-full mr-[20px] ml-[20px] max-w-[95%] sm:max-w-[90%] border-collapse bg-white">
            <tbody>
                <tr class="h-[120px]">
                    <td class="w-[25%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-bold leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'1. Long-term Hospitalization Allowance' | translate}}
                    </td>
                    <td class="w-[75%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-normal leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'In case the insured suffers an accident or illness within the policy coverage, requiring
                        inpatient treatment for 30 days
                        or more and continuous leave of at least 60 days (including hospitalization period)' |
                        translate}}
                    </td>
                </tr>
                <tr class="h-[120px]">
                    <td class="w-[25%]  px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-bold leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'2. Death benefit' | translate}}
                    </td>
                    <td class="w-[75%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-normal leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'Covers death caused by accident, illness, or disease during long-term treatment' |
                        translate}}
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="flex w-full max-w-[95%] sm:max-w-[90%] h-[80px] gap-2 items-center px-8 py-4
                            rounded-tl-[16px] border border-[rgba(255,255,255,0.16)]
                            bg-[linear-gradient(90deg,rgba(18,18,18,0.08)_0%,rgba(238,238,238)_7%)] mt-6">
            <img src="/png/CheckCircle.svg" alt="Check Circle" class="w-6 h-6 flex-shrink-0" style="fill: #1AAA69;" />
            <h1
                class="text-[#121212] font-[Manrope] text-[24px] not-italic font-semibold leading-[43.556px] flex-[1_0_0]">
                {{'Extended Coverage' | translate}}
            </h1>
        </div>
        <table class="w-full mr-[20px] ml-[20px] max-w-[95%] sm:max-w-[90%] border-collapse bg-white">
            <tbody>
                <tr class="h-[120px]">
                    <td class="w-[25%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-bold leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'1. Enhanced Hospitalization Allowance' | translate}}
                    </td>
                    <td class="w-[75%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-normal leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'Extended conditions for the Long-term Hospitalization Allowance' | translate}}
                    </td>
                </tr>
                <tr class="h-[120px]">
                    <td class="w-[25%]  px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-bold leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'2. Critical Illness Insurance' |translate}}
                    </td>
                    <td class="w-[75%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-normal leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'(cancer, heart attack, stroke)' | translate}}
                        <ol class="list-decimal" style="counter-reset: section 2;">
                            <li style="counter-increment: section 1; list-style-type: none;">
                                <span class="mr-2 before:content-[counter(section) '.']">2.1</span> {{'Early-stage
                                Critical
                                Illness' |translate}}
                            </li>
                            <li style="counter-increment: section 1; list-style-type: none;">
                                <span class="mr-2 before:content-[counter(section) '.']">2.2</span> {{'Late-stage
                                Critical
                                Illness' |translate}}
                            </li>
                        </ol>
                    </td>
                </tr>
                <tr class="h-[120px]">
                    <td class="w-[25%]  px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-bold leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'3. Women’s Cancer Protection (Breast Cancer and Cervical Cancer)' | translate}}
                    </td>
                    <td class="w-[75%] px-8 pt-8 pb-2 text-[#1B1B1B] font-[Manrope] text-[18px] font-normal leading-[140%] border border-[#E3E4E8] bg-white"
                        style="font-feature-settings: 'liga' off, 'clig' off;">
                        {{'(cancer, heart attack, stroke)' | translate}}
                        <ol class="list-decimal" style="counter-reset: section 2;">
                            <li style="counter-increment: section 1; list-style-type: none;">
                                <span class="mr-2 before:content-[counter(section) '.']">3.1.</span>
                                {{'Early-stage'|translate}}
                            </li>
                            <li style="counter-increment: section 1; list-style-type: none;">
                                <span class="mr-2 before:content-[counter(section) '.']">3.2.</span> {{'Late-stage' |
                                translate}}
                            </li>
                        </ol>

                    </td>
                </tr>
            </tbody>
        </table>
        <!--Third box-->
        <div
            class="flex flex-col sm:flex-row w-full max-w-[90%] mt-[32px] p-8 justify-center items-start gap-8 rounded-[32px] bg-[#F5375C] shadow-[0_4px_80px_0_rgba(0,0,0,0.08)]">
            <div class="flex flex-col justify-center items-center gap-4 flex-1">
                <h1 class="self-stretch text-white font-[Manrope] text-[32px] font-bold leading-[140%] tracking-[-2px]">
                    {{'Secure your financial peace of mind today' | translate}}
                </h1>
                <p
                    class="self-stretch text-white font-[Manrope] text-[20px] font-normal leading-[26px] rotate-[0.194deg]">
                    {{'Protect your finances from income loss due to illness, accident, or unforeseen circumstances' | translate}}
                </p>
            </div>
            <div (click)="onCoverage()"
                class="w-[300px] h-[70px] flex flex-col justify-center items-center self-center rounded-[89.857px] bg-[#2AD189] hover:bg-[#A4FFD6]  cursor-pointer transition-colors duration-300">
                <button class="text-[#1B1B1B] text-center font-[Manrope] text-[20px] font-bold leading-normal ">
                    {{'REGISTER NOW' | translate}}
                </button>
            </div>
        </div>
    </main>

    <!-- Footer -->
    <app-asahi-footer></app-asahi-footer>
</div>